import React from "react";
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';

const EnvasadoTerminadoSection = ({
  terminadoRecords = []
}) => {
  return (
    <div className="animate-fadeIn">
      <div className="history-section-header">
        <div>
          <h2>Inventarios de Mezcal Envasado "Terminado" (Sección IV)</h2>
          <p style={{ margin: 0, color: "var(--text-muted)", fontSize: "13px" }}>
            Registro de lotes de producto terminado generados tras completar el envasado y asignación de hologramas.
          </p>
        </div>
      </div>

      <div className="records-list-wrapper">
        <table className="records-table">
          <thead>
            <tr>
              <th colSpan="7" style={{ textAlign: "center", background: "rgba(74, 93, 35, 0.2)", color: "var(--agave-green)" }}>Datos Generales / Identificación de Etiqueta</th>
              <th colSpan="2" style={{ textAlign: "center" }}>Finalización</th>
            </tr>
            <tr>
              {/* Identificación */}
              <th>Fecha Mov.</th>
              <th>Bot/Caja</th>
              <th>Marca</th>
              <th>Lote Granel</th>
              <th>Lote Env.</th>
              <th>Categoría</th>
              <th>Clase Etiqueta</th>

              {/* Cierre */}
              <th>V.Bo. Inspector</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            {terminadoRecords.map((rec, i) => (
              <tr key={i}>
                <td>{rec.fechaMovimiento}</td>
                <td>{rec.botCaja}</td>
                <td style={{ fontWeight: 800 }}>{rec.marca}</td>
                <td>{rec.noLoteGranel}</td>
                <td style={{ color: "var(--copper)", fontWeight: 700 }}>{rec.loteEnvasado}</td>
                <td>{rec.categoria}</td>
                <td>{rec.claseEtiqueta}</td>

                <td style={{ fontSize: "11px" }}>{rec.inspector}</td>
                <td>
                  <span className={`badge-status ${rec.status}`}>
                    {rec.status === "aprobado" ? "Aprobado" : rec.status === "revision" ? "En revisión" : "Borrador"}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EnvasadoTerminadoSection;
